export default __webpack_public_path__ + "static/media/logo.4af8996c.png";